module.exports = __webpack_public_path__ + "static/media/invoice.a285fe79.svg";